import { Box, styled, Typography } from '@razz-team/ui-web';
import { useTranslation } from 'react-i18next';
import { memo } from 'react';

const AboutContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
  position: 'relative',
  overflow: 'hidden',
  background: '#000',
});

const VideoBackground = styled('video')({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  zIndex: 1,
});

const Overlay = styled(Box)({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundColor: 'rgba(0, 0, 0, 0.4)',
  zIndex: 2,
});

const ContentContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  zIndex: 3,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  padding: theme.spacing(8),
  color: 'white',
}));

export const WolfoAuthAbout = memo(function WolfoAuthAbout() {
  const { t } = useTranslation();

  return (
    <AboutContainer>
      <VideoBackground autoPlay muted loop playsInline>
        <source src="https://wolfo.io/img/bg-video.mp4" type="video/mp4" />
      </VideoBackground>
      <Overlay />
      <ContentContainer>
        <Typography
          variant="h2"
          sx={{
            fontSize: { xs: '32px', md: '48px' },
            fontWeight: 700,
            lineHeight: 1.2,
            marginBottom: 4,
            textShadow: '0 2px 4px rgba(0,0,0,0.5)',
          }}
        >
          {t('Next-Generation Digital Banking')}
        </Typography>
        <Typography
          variant="h5"
          sx={{
            fontSize: { xs: '16px', md: '20px' },
            fontWeight: 400,
            lineHeight: 1.5,
            maxWidth: '400px',
            textShadow: '0 1px 2px rgba(0,0,0,0.5)',
            opacity: 0.9,
          }}
        >
          {t('Empowering businesses with innovative financial solutions for the modern world')}
        </Typography>
      </ContentContainer>
    </AboutContainer>
  );
});
